import { defineComponent as _defineComponent } from 'vue';
import { SIcon } from '@strana-artw/ui-kit';
import { defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'MenuDesktopActivator',
  setup: function setup(__props) {
    defineComponent({
      name: 'MenuDesktopActivator'
    });
    return {
      __sfc: true,
      SIcon: SIcon
    };
  }
});